import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/provide/auth.service';
import { CommonService } from 'src/app/provide/common.service';
import { ApiEndPoint } from 'src/app/config/api-end-point';
@Component({
    selector: 'app-customer-product-list',
    templateUrl: './customer-product-list.component.html',
    styleUrls: ['./customer-product-list.component.scss'],
    standalone: false
})
export class CustomerProductListComponent implements OnInit {
  _id: any
  currentPage = 1;
  // Number of products per page
  pageSize = 32;
  serviceName: any
  latitude: any;
  longitude: any;
  isLoggedIn: any
  loggedInUserType: any
  headingName:any ='PRODUCTS'
  recomendtation = "0"
  linkerRouteItems:any =[
    { name:'Home',route: '/home'},
    {name:'Products',route:'/customer-product-list'}
  ]
  
  // Make Math available in template
  Math = Math;
  constructor(private activatedroute: ActivatedRoute, public authService: AuthService, public commonService: CommonService, private router: Router) {
    this.activatedroute.queryParams.subscribe((res: any) => {
      this._id = res._id;
      this.recomendtation = res.recomendtation
      if(!this.recomendtation){
        this.recomendtation = localStorage.getItem("recomendation")
      }
    })
    
  }

  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe((res: any) => {
      this.isLoggedIn = res
    })
    this.isLoggedIn = this.authService.isLogin()
    this.authService.loggedInUserType.subscribe((res: any) => {
      this.loggedInUserType = res
    })
    this.loggedInUserType = this.authService.checkUserTypeLoggedIn()
    
    navigator.geolocation.getCurrentPosition(function (position) {
      // alert('allow');  
    }, function () {
      // alert('You need to enable geolocation services in your browser to use this feature.');
    });
    this.getPosition().then(pos => {
      localStorage.setItem('location', JSON.stringify(pos))
    });
    
    // Get location first, then load products with location data
    this.getLocation();

  }
  getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {

      navigator.geolocation.getCurrentPosition(resp => {

        resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
      },
        err => {
          reject(err);
        });
    });

  }

  getLocation() {
    // Show loading state while getting location
    this.isLoading = true;
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position) {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            console.log('Location obtained:', this.latitude, this.longitude);
            // Load products with location data
            this.getProducts();
          }
        },
        (error) => {
          console.log('Geolocation error:', error);
          // If geolocation fails, show message and load products without location
          alert("Unable to get your location. Showing all products.");
          this.latitude = 0;
          this.longitude = 0;
          this.getProducts();
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000 // 5 minutes
        }
      );
    } else {
      alert("Geolocation is not supported by this browser. Showing all products.");
      this.latitude = 0;
      this.longitude = 0;
      this.getProducts();
    }
  }

  userId: any;
  productDetails: any;
  productId: any;
  retailerId: any;
  imgurl: any;
  imageLinks: any
  totalItems: any
  bannerData: any = []
  // get retailer detail by id
  getProducts() {
    if (this.isLoggedIn) {
      this.getproductwithLogin()
    } else {
      this.getproduct()
    }
  }
  user: any
  getproduct() {
    let url = `product/listProductBySortion`
    if (this.loggedInUserType == 'RETAILER') {
      this.user = 'WHOLE_SALER'
    } else {
      this.user = 'RETAILER'
    }
    let data = {
      // "dealType" :  "PRODUCT",
      "userType":this.user,
      'lng': this.longitude || 0,
      'lat': this.latitude || 0,
      'page': this.currentPage,
      'limit': this.pageSize,
      search: this.serviceName || '',
      recomendtation : false
    }
    
    this.commonService.removeEmptyKey(data)
    this.bannerData = []
    this.commonService.postApi(url, data, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.bannerData = res["result"]["docs"];
        this.totalItems = res['result']['count']
        if (!this.bannerData.length) {
          this.isLoading = true;
        } else {
          this.isLoading = false;
        }
        this.commonService.hideSpinner()
      } else {
        this.totalItems = 0
        this.isLoading = true;
        this.bannerData = []
        this.commonService.hideSpinner()
      }
    }, (err) => {
      this.isLoading = true;
      this.totalItems = 0
      this.bannerData = []
      this.commonService.hideSpinner()
    })
  }
  isLoading: boolean = false
  getproductwithLogin() {
    let url = `product/listProductBySortion`
    if (this.loggedInUserType == 'RETAILER') {
      this.user = 'WHOLE_SALER'
    } else {
      this.user = 'RETAILER'
    }
    let data = {
      // "dealType" :  "PRODUCT",
      "userType": this.user,
      'lng': this.longitude || 0,
      'lat': this.latitude || 0,
      'page': this.currentPage,
      'limit': this.pageSize,
      search: this.serviceName || '',
      recomendtation : false
    }
    if(this.recomendtation == "1"){
      data.recomendtation = true
    }
    
    this.commonService.removeEmptyKey(data)
    this.bannerData = []
    this.commonService.postApi(url, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {

        this.bannerData = res["result"]["docs"];
        // Set default isLike status for all products
        this.bannerData.forEach(product => {
          if (product.isLike === undefined) {
            product.isLike = false;
          }
        });
        this.totalItems = res['result']['count']
        if (!this.bannerData.length) {
          this.isLoading = true;
        } else {
          this.isLoading = false;
        }
        this.commonService.hideSpinner()
      } else {
        this.totalItems = 0
        this.bannerData = []
        this.commonService.hideSpinner()
      }
    }, (err) => {
      this.totalItems = 0
      this.bannerData = []
      this.commonService.hideSpinner()
    })
  }
  navigateToViewProduct(_id) {
    this.router.navigate(['/product-view-customer'], { queryParams: { _id: _id } })
  }
  pagination(event) {
    this.currentPage = event;
    this.getProducts();
  }
  
  // New pagination methods
  goToPage(page: number) {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
      this.getProducts();
    }
  }
  
  getPageNumbers(): number[] {
    const totalPages = this.getTotalPages();
    const pages: number[] = [];
    const maxVisiblePages = 5;
    
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(totalPages, start + maxVisiblePages - 1);
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
    }
    
    return pages;
  }
  
  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }
  
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  
  // Enhanced price display method
  getDisplayPrice(item: any) {
    console.log('Getting price for item:', item);
    
    // Check for priceSizeDetails array first (this is the actual structure)
    if (item?.priceSizeDetails && Array.isArray(item.priceSizeDetails) && item.priceSizeDetails.length > 0) {
      const priceDetail = item.priceSizeDetails[0];
      if (priceDetail?.price && priceDetail.price > 0) {
        const price = priceDetail.price;
        console.log('Found price in priceSizeDetails:', price);
        const formattedPrice = this.getPrice(price) || 'R' + price.toFixed(2);
        console.log('Formatted price:', formattedPrice);
        return formattedPrice;
      }
    }
    
    // Check for dealPrice if it's a deal
    if (item?.dealPrice && item.dealPrice > 0) {
      console.log('Found deal price:', item.dealPrice);
      const formattedPrice = this.getPrice(item.dealPrice) || 'R' + item.dealPrice.toFixed(2);
      return formattedPrice;
    }
    
    // Try different direct price fields as fallback
    const priceFields = [
      'price', 'sellingPrice', 'productPrice', 'cost', 'amount', 
      'currentPrice', 'salePrice', 'finalPrice', 'unitPrice',
      'pricePerUnit', 'retailPrice', 'wholesalePrice'
    ];
    
    let price = null;
    let foundField = null;
    
    for (const field of priceFields) {
      if (item?.[field] !== undefined && item[field] !== null && item[field] !== '' && !isNaN(parseFloat(item[field]))) {
        const numPrice = parseFloat(item[field]);
        if (numPrice > 0) {
          price = numPrice;
          foundField = field;
          break;
        }
      }
    }
    
    console.log('Found price:', price, 'from field:', foundField);
    
    if (price) {
      const formattedPrice = this.getPrice(price) || 'R' + price.toFixed(2);
      console.log('Formatted price:', formattedPrice);
      return formattedPrice;
    }
    
    return 'R0.00';
  }
  
  getOriginalPrice(item: any) {
    // Check if there's a deal price (which would be the original price)
    if (item?.dealPrice && item.dealPrice > 0) {
      // If there's a deal price, the original price might be in priceSizeDetails
      if (item?.priceSizeDetails && Array.isArray(item.priceSizeDetails) && item.priceSizeDetails.length > 0) {
        const priceDetail = item.priceSizeDetails[0];
        if (priceDetail?.price && priceDetail.price > item.dealPrice) {
          return this.getPrice(priceDetail.price) || 'R' + priceDetail.price.toFixed(2);
        }
      }
    }
    
    // Try different original price fields
    const originalPriceFields = ['originalPrice', 'mrp', 'listPrice', 'regularPrice'];
    let originalPrice = null;
    
    for (const field of originalPriceFields) {
      if (item?.[field] && item[field] > 0) {
        originalPrice = item[field];
        break;
      }
    }
    
    if (originalPrice) {
      return this.getPrice(originalPrice) || 'R' + originalPrice.toFixed(2);
    }
    
    return null;
  }
  
  getDiscountPercentage(item: any) {
    const currentPrice = this.getDisplayPrice(item);
    const originalPrice = this.getOriginalPrice(item);
    
    if (!originalPrice || currentPrice === originalPrice) {
      return 0;
    }
    
    // Extract numeric values from currency strings
    const currentValue = parseFloat(currentPrice.replace('R', '').replace(',', ''));
    const originalValue = parseFloat(originalPrice.replace('R', '').replace(',', ''));
    
    if (originalValue <= 0 || currentValue >= originalValue) {
      return 0;
    }
    
    return Math.floor(((originalValue - currentValue) / originalValue) * 100);
  }
  
  // Debug method to check product data structure
  debugProductData(item: any) {
    console.log('=== PRODUCT DEBUG ===');
    console.log('Full product data:', item);
    console.log('Product name:', item?.productName);
    console.log('All price-related fields:');
    
    // Check all possible price fields
    const priceFields = [
      'price', 'sellingPrice', 'productPrice', 'cost', 'amount',
      'currentPrice', 'salePrice', 'finalPrice', 'unitPrice',
      'pricePerUnit', 'retailPrice', 'wholesalePrice',
      'originalPrice', 'mrp', 'listPrice', 'regularPrice'
    ];
    
    priceFields.forEach(field => {
      if (item?.[field] !== undefined) {
        console.log(`${field}:`, item[field], `(type: ${typeof item[field]})`);
      }
    });
    
    // Check all numeric fields
    console.log('All numeric fields:');
    for (const key in item) {
      if (item.hasOwnProperty(key) && typeof item[key] === 'number') {
        console.log(`${key}:`, item[key]);
      }
    }
    
    console.log('=== END DEBUG ===');
  }
  addWishlist(id) {
    let apiReqUrl = `user/addWishListProduct?productId=${id}`
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.commonService.hideSpinner();
        this.getProducts()
        // this.router.navigate(['/edit-product'])
        this.commonService.successToast('Product added to wishlist.');
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
        if (res.responseCode == 401) {
          this.router.navigate[('/login')]
        }
      }
    }, (err) => {
      this.commonService.hideSpinner()
      if (err.responseCode == 401) {
        this.router.navigate[('/login')]
      }
    })
  }
  
  // Toggle wishlist functionality
  toggleWishlist(productId: string, event: Event) {
    event.stopPropagation(); // Prevent card click navigation
    
    if (!this.isLoggedIn) {
      this.commonService.errorToast('Please login to add items to wishlist');
      return;
    }
    
    // Find the product in the current list
    const product = this.bannerData.find(item => item._id === productId);
    if (!product) return;
    
    console.log('Toggle wishlist for product:', productId, 'Current isLike status:', product.isLike);
    
    if (product.isLike) {
      // Remove from wishlist
      console.log('Removing from wishlist');
      this.removeFromWishlist(productId);
    } else {
      // Add to wishlist
      console.log('Adding to wishlist');
      this.addToWishlist(productId);
    }
  }
  
  addToWishlist(productId: string) {
    const apiReqUrl = `${ApiEndPoint.addWishListProduct}?productId=${productId}`;
    this.commonService.showSpinner();
    
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      this.commonService.hideSpinner();
      if (res.responseCode == 200) {
        // Update the product's wishlist status
        const product = this.bannerData.find(item => item._id === productId);
        if (product) {
          product.isLike = true;
        }
        this.commonService.successToast('Product added to wishlist.');
      } else {
        this.commonService.errorToast(res.responseMessage || 'Failed to add to wishlist');
      }
    }, (err) => {
      this.commonService.hideSpinner();
      this.commonService.errorToast('Something went wrong');
    });
  }
  
  removeFromWishlist(productId: string) {
    // Use the same addWishListProduct endpoint - it's a toggle function!
    // The backend will automatically remove the item if it's already in wishlist
    const apiReqUrl = `${ApiEndPoint.addWishListProduct}?productId=${productId}`;
    this.commonService.showSpinner();
    
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      this.commonService.hideSpinner();
      if (res.responseCode == 200) {
        // Update the product's wishlist status
        const product = this.bannerData.find(item => item._id === productId);
        if (product) {
          product.isLike = false;
        }
        this.commonService.successToast('Item removed from wishlist');
      } else {
        this.commonService.errorToast(res.responseMessage || 'Failed to remove from wishlist');
      }
    }, (err) => {
      this.commonService.hideSpinner();
      this.commonService.errorToast('Something went wrong');
    });
  }

  length(n){
    return new Array(n)
  }
}
